"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Div_1 = __importDefault(require("../Div"));
var PriceSok = function (_a) {
    var sokItemPriceStyles = _a.sokItemPriceStyles, sokItemIntegersStyles = _a.sokItemIntegersStyles, sokItemDecimalsStyles = _a.sokItemDecimalsStyles, sokItemUnitStyles = _a.sokItemUnitStyles, priceIntegers = _a.priceIntegers, priceDecimals = _a.priceDecimals, unit = _a.unit;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Div_1.default, { styles: sokItemPriceStyles },
        react_1.default.createElement("div", { style: sokItemIntegersStyles }, priceIntegers),
        react_1.default.createElement("div", { style: sokItemDecimalsStyles }, priceDecimals),
        react_1.default.createElement("div", { style: sokItemUnitStyles }, 
        // use empty string if translation not found
        t("product.unit.".concat(unit), { defaultValue: '' }))));
};
exports.default = PriceSok;
//# sourceMappingURL=PriceSok.js.map